export default __webpack_public_path__ + "static/media/dominique.c946cd4d.png";